import React, { Fragment, Component } from 'react'
import { Head, withSiteData } from 'react-static'

import NewFooter from '../../blocks/NewFooter/NewFooterV2'
import NewMainBanner from '../../blocks/NewMainBanner/NewMainBannerv3'
import NewMainBanner2 from '../../blocks/NewMainBanner/NewMainBannerv4'
import CardsMercosCustomers from '../../blocks/CardsMercosCustomers/CardsMercosCustomersv3'
import NewOurResults from '../../blocks/NewOurResults/NewOurResultsv2'

import NewMenu from '../../blocks/Menu/NewMenu'
import SliderTestimonialCardStars from '../../components/site/TestimonialCardStars/SliderTestimonialCardStars'
import CardTrialNew from '../../blocks/CardFooter/CardTrialv2'
import AccordionContainer from '../../components/site/Accordion/AccordionContainer'
import AccordionItem from '../../components/site/Accordion/AccordionItem'

import './NewHomev3.scss'
import SalesAutomation from '../../blocks/TwoCols/SalesAutomation'
import HomeSolutions from '../../blocks/TwoCols/HomeSolutions'
import SellOnlineB2B from '../../blocks/TwoCols/SellOnlineB2B'
import MercosPay from '../../blocks/TwoCols/MercosPay'
import CardsEstrategiasHome from '../../blocks/CardsEstrategias/CardsEstrategiasHome'

class NewHomev2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            abTest: false
        };
    }

    componentDidMount() {
        let counter = 0;
        const intervalId = setInterval(() => {
            if (globalThis.abTest) {
                this.setState({ abTest: globalThis.abTest });
                clearInterval(intervalId);

                const btnModalElements = document.querySelectorAll('.btn-modal');
                const btnTrialElements = document.querySelectorAll('.btn-trial');

                btnModalElements.forEach((element, index) => {
                    element.id = `variation-btn-modal-${index + 1}`;
                });
                btnTrialElements.forEach((element, index) => {
                    element.id = `variation-btn-trial-${index + 1}`;
                });
            } else {
                counter++;
                if (counter >= 10) {
                    clearInterval(intervalId);
                    const btnModalElements = document.querySelectorAll('.btn-modal');
                    const btnTrialElements = document.querySelectorAll('.btn-trial');

                    btnModalElements.forEach((element, index) => {
                        element.id = `btn-modal-${index + 1}`;
                    });
                    btnTrialElements.forEach((element, index) => {
                        element.id = `btn-trial-${index + 1}`;
                    });
                }
            }
        }, 200);
    }


    render() {
        return (
            <Fragment>
                <div className={`new-home new-home-v3 new-layout`}>
                    <NewMenu
                        pixelsToShowMenuWhite={50}
                        mutableMenu
                    />
                    <Head>
                        <title>Mercos: Sistema de Vendas e E-commerce B2B</title>
                        <meta
                            name="description"
                            content="Venda mais e organize sua operação comercial! O Mercos é o sistema mais prático e completo do mercado. Ideal para Indústria, Distribuidora e Representante."
                        />
                        <link rel='canonical' href='https://mercos.com' />
                    </Head>

                    {this.state.abTest === "a" ?
                        <NewMainBanner title="Transforme seus processos comerciais com o Mercos" description="Esqueça as planilhas e os pedidos manuais. Com o Mercos, você tem controle total das vendas e pedidos, permitindo que você se concentre no que realmente importa: o crescimento da sua empresa." imgSrc="/images/site/new-home/hero-1.png" imgMobileSrc="/images/site/new-home/hero-1-mobile.png" buttonShadow />
                        :
                        this.state.abTest === "b" ?
                            <NewMainBanner title="Melhore a eficiência e produtividade da sua equipe comercial" description="Sua equipe tem à disposição automação de pedidos, controle das vendas, faturamento e estoque, além de relatórios completos para analisar desempenho e auxiliar na gestão dos vendedores e clientes." imgSrc="/images/site/new-home/hero-1.png" imgMobileSrc="/images/site/new-home/hero-1-mobile.png" buttonShadow />
                            :
                            this.state.abTest === "c" ?
                                <NewMainBanner title="Automatize a emissão de pedidos e venda online 24 hrs por dia" description="Receba pedidos offline, emita relatórios, controle o estoque, venda online de empresa para empresa e muito mais. Tudo integrado ao seu ERP com o Força de vendas e E-commerce B2B da Mercos." imgSrc="/images/site/new-home/hero-1.png" imgMobileSrc="/images/site/new-home/hero-1-mobile.png" buttonShadow />
                                :
                                <NewMainBanner />
                    }
                    <CardsMercosCustomers />
                    <NewOurResults />
                    <HomeSolutions />
                    <SalesAutomation />
                    <SellOnlineB2B />
                    <MercosPay />

                    <section className="testimonials">
                        <SliderTestimonialCardStars descriptionH4 newHome overtitle title="+8,3 mil clientes melhoram a sua operação comercial com a Mercos." />
                    </section>

                    <CardsEstrategiasHome />

                    <div className="home-accordion">
                        <div className="container">
                            <h5 className='title'>Perguntas frequentes</h5>
                            <h3 className="description">Não conhece o e-commerce B2B e força de vendas da Mercos? <br />
                                Confira as principais dúvidas que podem surgir.</h3>
                            <AccordionContainer expand='arrow' collapsable defaultClosed>
                                <AccordionItem heading2 classes={{ titleOpened: 'accordion-title-selected' }} title='O que é o força de vendas da Mercos?' onClick={() => this.setState({ itemOpened: FORCA_VENDAS })}>
                                    <h3>O força de Vendas da Mercos é o sistema de automação usado por equipes de vendas externas para fazer pedidos, orçamentos e vendas, além de análise de indicadores comerciais. É o sistema de vendas mais prático e completo do mercado.</h3>
                                    <h3>Com ele, o vendedor externo ou representante consegue emitir pedidos sem erros, com tabelas atualizadas automaticamente pelo aplicativo online e offline, por Android ou iOS. O gestor de vendas consegue analisar todos os dados de vendas em tempo real e trazer muito mais inteligência para o seu negócio.</h3>
                                </AccordionItem>
                                <AccordionItem heading2 classes={{ titleOpened: 'accordion-title-selected' }} title='O que é o e-commerce B2B da Mercos?' onClick={() => this.setState({ itemOpened: ECOMMERCE })}>
                                    <h3>E-commerce B2B é uma loja virtual para quem vende para outras empresas. Os clientes precisam de autorização para ver as informações dos produtos e os preços, que são vinculados à tabela de cada cliente.</h3>
                                    <h3>O e-commerce B2B da Mercos também permite que as vendas sejam vinculadas ao vendedor responsável pelo cliente e oferece diversos indicadores para uma venda mais inteligente e estratégica.</h3>
                                </AccordionItem>
                                <AccordionItem heading2 classes={{ titleOpened: 'accordion-title-selected' }} title='Quem pode usar o Mercos?' onClick={() => this.setState({ itemOpened: QUEM_PODE_USAR })}>
                                    <h3>Qualquer empresa que venda produtos físicos e tenha vendas recorrentes para outras empresas pode usar o Mercos. Ele é indicado especialmente para indústrias, distribuidoras e representantes comerciais.</h3>
                                </AccordionItem>
                                <AccordionItem heading2 classes={{ titleOpened: 'accordion-title-selected' }} title='Como faço para agendar uma demonstração?' onClick={() => this.setState({ itemOpened: AGENDAR_DEMONSTRACAO })}>
                                    <h3>Clique em “peça uma demonstração”, preencha seus dados e nosso time de especialistas entrará em contato para passar mais informações.</h3>
                                </AccordionItem>
                                <AccordionItem heading2 classes={{ titleOpened: 'accordion-title-selected' }} title='Como faço para testar o Mercos?' onClick={() => this.setState({ itemOpened: TESTAR })}>
                                    <h3>Clique em “teste grátis” e preencha os seus dados para acessar a versão completa do Mercos gratuitamente por 7 dias. Não é necessário utilizar seu cartão de crédito para o teste.</h3>
                                </AccordionItem>
                            </AccordionContainer>
                        </div>
                    </div>

                    <CardTrialNew text={['Evolua sua operação', <br />, ' comercial com o Mercos']} horizontalCard trialText="comece grátis" demoButton />
                    <NewFooter />

                </div>
            </Fragment>
        )

    }

}

export default withSiteData(NewHomev2);


// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/NewHomev3.jsx